export default "__VITE_ASSET__e44be0c4__"